module.exports = __webpack_public_path__ + "static/media/coreboard.ae1b4573.png";